'use strict';

class Contact {
	constructor(props = {}) {
		this.form_contact = document.getElementById('form_contact');
		this.contact_methods = document.getElementById('contact_methods');
		this.contact_methods_selector = document.getElementById('contact_methods_selector');
		this.contact_methods_holder = document.getElementById('contact_methods_holder');
		this.method_buttons = this.contact_methods_selector?.querySelectorAll('button');
		this.confirmation = document.querySelector('#contact-confirmation-holder');
		this.selected_method = null;
		let _that = this;
		_that = Object.assign(this, props);
		console.log('Contact::constructor(%o)', props);

		if (this.contact_methods_selector) {
			this.method_buttons.forEach(button => {
				button.addEventListener('click', () => {
					this.selected_method = button.value;
					this.displayContactMethod(this.selected_method);
				});
			});

			if (this.selected_method) {
				this.displayContactMethod(this.selected_method);
			}

		}

		try {
			document.getElementById('chat_offset').value = new Date().getTimezoneOffset();
		} catch (e) {
			console.error(e);
		}

		try {			
			this.addValidator();
		} catch (e) {
			console.error(e);
		}

		const open_existing_chat = document.getElementById('open_existing_chat');
		if (open_existing_chat) {
			open_existing_chat.addEventListener('click', () => {
				this.openChatWindow('chat_window');
			});
		}
	}

	openChatWindow(window_target) {
		const features = [
			'popup=1',
			'toolbar=0',
			'scrollbars=0',
			'location=0',
			'statusbar=0',
			'menubar=0',
			'resizable=0',
			'width=500',
			'height=700',
		];
		window.open(url('/chat/window'), window_target, features.join(','));
	}

	displayContactMethod(name) {
		console.log('displayContactMethod(%o)', name);
		switch (name.toLowerCase()) {
			case 'email_reply':
				this.form_contact.setAttribute('action', url('/process_contact'));
				break;

			case 'chat_with_us':
				this.form_contact.setAttribute('action', url('/chat/window'));
				break;

			default:
				this.form_contact.setAttribute('action', url('/'));
		}

		console.log(this.form_contact.getAttribute('action'));

		const methods = this.contact_methods_holder.querySelectorAll('.contact_method');
		methods.forEach(method => {
			if (method.dataset[name] === '1') {
				method.classList.remove('hidden');
			} else {
				method.classList.add('hidden');
			}
		});
		this.method_buttons.forEach(method_button => {
			if (method_button.value === name) {
				method_button.classList.add('active');
			} else {
				method_button.classList.remove('active');
			}
		});
	}

	addValidator() {
		if (this.form_contact) {
			const errorHandler = (input, errors, form, container) => {
				if (!errors) {
					input.classList.remove('inputError');
					input.parentElement.classList.remove('has-error');
				} else if (['name', 'email', 'phone'].indexOf(input.name) != -1 ) {
					input.classList.add('inputError');
					input.parentElement.classList.add('has-error');
					input.parentElement.insertAdjacentElement('afterend', container);
				} else {
					input.classList.add('inputError');
					input.insertAdjacentElement('afterend', container);
				}
			};

			const formSubmitHandler = () => {
				$(':submit', this.form_contact).prop('disabled', true);
				if (this.selected_method === 'chat_with_us') {
					this.openChatWindow('chat_window');
					this.form_contact.target = 'chat_window';
					this.form_contact.submit();
				} else {
					this.form_contact.target = '_self';

					const formData = new FormData(this.form_contact);
					const contact = fetcher(
						url('/process_contact'),
						{
							method: 'post',
							body: formData,
						}
					);

					contact.ready.then((response) => {
						this.form_contact.classList.add('d-none');
						this.contact_methods_selector.classList.add('d-none');

						if (response == 'true' || response == true) {
							this.confirmation.querySelector('.js-confirmation-success').classList.remove('d-none');
						} else {
							this.confirmation.querySelector('.js-confirmation-failed').classList.remove('d-none');
						}
						this.contact_methods.scrollIntoView({ behavior: "smooth" });

					}).catch(() => {
						this.form_contact.classList.add('d-none');
						this.contact_methods_selector.classList.add('d-none');
						this.confirmation.querySelector('.js-confirmation-failed').classList.remove('d-none');
						this.contact_methods.scrollIntoView({ behavior: "smooth" });
					});
				}
				$(':submit', this.form_contact).prop('disabled', false);
			}
			
			const constraints = {
				name: { presence: true },
				email: {
					presence: true,
					email: true
				},
				phone: {
					presence: true,
					numericality: {
						onlyInteger: true,
						message: '^' + messages.ERROR_ENTER_DIGITS_ONLY
					}
				},
				category_name: { 
					presence: {
						message: '^' + messages.CONTACT_PAGE_CATEGORY
					} 
				},
				message: {
					presence: true,
					length: {
						minimum: 20,
						maximum: 5000,
						message: '^' + it('ERROR_ENTER_TEXT_BETWEEN').replace('{0}', 20).replace('{1}', 5000),
					}
				}
			}

			new FormValidator({formSubmitHandler, errorHandler, isInvalid: 'inputError'}).start(this.form_contact, constraints);
		}
	}
}

window.addEventListener('DOMContentLoaded', () => {
	try {
		new Contact(contact_options || {});
	} catch (e) {
		console.error(e);
	}
});
